import { Hooks, Row } from 'react-table';
import React from 'react';
import { IVehiclePayload } from 'modules/core/types';

import { TableCheckbox } from '../TableCheckbox';
import { SelectCell } from './styles';
import { SELECT_ALL_COLUMN_ID } from '../table.const';

export const useSelectableColumns = (selectable: boolean) => (hooks: Hooks): void => {
  if (selectable) {
    hooks.visibleColumns.push((cols) => [
      {
        id: SELECT_ALL_COLUMN_ID,
        Header: ({ getToggleAllRowsSelectedProps }) => (
          <div>
            <TableCheckbox {...getToggleAllRowsSelectedProps()} />
          </div>
        ),
        Cell: ({ row }: { row: Row<IVehiclePayload> }) => (
          <SelectCell>
            <TableCheckbox {...row.getToggleRowSelectedProps()} />
          </SelectCell>
        ),
      },
      ...cols,
    ]);
  }
};
